import { JourneyStepType } from '../../../types'
import { SingleSelect } from '../../../ui/form/SingleSelect'
import TextInput from '../../../ui/form/TextInput'
import { LimitStepIcon } from '../../../ui/icons'
import { useTranslation } from 'react-i18next'

interface LimitStepConfig {
    rate_limit?: number
    rate_interval?: 'second' | 'minute' | 'hour' | 'day' | 'week'
}

export const limitStep: JourneyStepType<LimitStepConfig> = {
    name: 'limit',
    icon: <LimitStepIcon />,
    category: 'flow',
    description: 'limit_desc',
    Describe: ({ value }) => {
        const { t } = useTranslation()
        if (!value.rate_limit) return <>{t('limit_desc_empty')}</>
        return <div style={{ maxWidth: 300 }}>{t('limit_desc_values', { ...value })}</div>
    },
    newData: async () => ({
        rate_limit: 0,
        rate_interval: 'minute',
    }),
    Edit: ({
        onChange,
        value,
        disabled,
    }) => {
        const { t } = useTranslation()
        type RateInterval = NonNullable<LimitStepConfig['rate_interval']>
        const intervals: Array<{ key: RateInterval, label: string }> = [
            { key: 'second', label: t('second') },
            { key: 'minute', label: t('minute') },
            { key: 'hour', label: t('hour') },
            { key: 'day', label: t('day') },
            { key: 'week', label: t('week') },
        ]
        return (
            <div style={{ maxWidth: 300 }}>
                {t('limit_edit_desc')}

                <SingleSelect
                    label={t('period')}
                    options={intervals}
                    value={value.rate_interval}
                    getOptionDisplay={o => o.label}
                    toValue={o => o.key}
                    onChange={rate_interval => onChange({ ...value, rate_interval })}
                    disabled={disabled}
                />

                <TextInput
                    name="rate_limit"
                    label={t('rate_limit')}
                    type="number"
                    value={value.rate_limit}
                    onChange={rate_limit => onChange({ ...value, rate_limit })}
                    disabled={disabled}
                />
            </div>
        )
    },
    sources: ['allowed', 'limited'],
}
